'use client';
import Script from 'next/script';

export default function GamInit() {
  return (
    <>
      <Script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" strategy="afterInteractive" />
      <Script id="gpt-init" strategy="afterInteractive">{`
        window.googletag = window.googletag || { cmd: [] };
        googletag.cmd.push(function () {
          // Empty slots should not leave large gaps when GAM has no eligible ad.
          googletag.pubads().collapseEmptyDivs(true);
          // Enable aggressive lazy loading - ads only fetch when very close to viewport
          googletag.pubads().enableLazyLoad({
            fetchMarginPercent: 50,  // Fetch when within 50% of viewport
            renderMarginPercent: 25, // Render when within 25% of viewport
            mobileScaling: 2         // Double margins on mobile for better UX
          });
          googletag.enableServices();
        });
      `}</Script>
    </>
  );
}
